/**
 * v-hasPermi 操作权限处理
 */

import usePermissionStore from "@/store/modules/permission";

function checkPermission(el, binding) {
  // 获取对应的缺陷
  const { value } = binding;
  // 获取当前用户的所有功能权限
  const buttonPermission = usePermissionStore().buttonPermission;
  const admin = usePermissionStore().admin;
  if (admin  || value === undefined) {
    return true;
  }

  // value 必须是一个数组
  else if (value && value instanceof Array && value.length > 0) {
    // 匹配对应的指令
    const hasPermission = buttonPermission[value];
    // 匹配失败
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  } else {
    throw new Error(`请设置操作权限标签值`);
  }
}

export default {
  // 在绑定元素的父组件被挂载之后调用
  mounted(el, binding) {
    checkPermission(el, binding);
  },
  // 在包含组件的 VNode 及子组件的 VNode 更新后调用
  update(el, binding) {
    checkPermission(el, binding);
  },
};
